import { Chicken } from '../types/Chicken';

export const ChickenTableRow = ({ chicken, image, prefixUrl }: { chicken: Chicken, image: string, prefixUrl: string }) => {
	const { id, simple } = chicken.attributes;

  return (
    <>
      <tr className="relative hover:bg-base-200 cursor-pointer">
        <td>
          <div className="flex items-center gap-3">
            <div>
                <img src={image} alt={simple.name} className="object-cover min-w-40 max-w-40 rounded-md max-h-[200px]" />
            </div>
            <div>
              <a href={`${prefixUrl}/${id}`} className="font-bold after:absolute after:inset-0 after:z-10">
                <div className="font-bold">{simple.name}</div>
              </a>
            </div>
          </div>
        </td>
        <td>
         { (simple.score*100).toFixed(2) }% 
        </td>
      </tr>
    </>
  );
};

export default ChickenTableRow;
